export const DEBOUNCE_TIMES = {
  default: 500,
  short: 200,
  long: 3000,
  fiveSeconds: 5000,
} as const;

export const DATE_TIME_FORMATS = {
  date: 'YYYY-MM-DD',
  time: 'HH:mm:ss',
  dateTime: 'YYYY-MM-DD HH:mm',
  dateTimeIso: '', // equivalent to ISO8601, zulu format
  dateIso: 'YYYY-MM-DD[T00:00:00.000Z]',
} as const;

/** The minimum number of elements required to show the search field. Used for cipo-select */
export const LIST_SEARCH_THRESHOLD = 5;

export const FILE_SIZE_CONVERT = {
  KB: 1024,
  MB: 1024 * 1024,
  GB: 1024 * 1024 * 1024,
} as const;

export const FILE_SIZES = {
  maxFileSize: 30 * 1024 * 1024, // 30MB
  chunkSize: 25 * 1024 * 1024, // 25MB
  chunkUploadConcurrency: 4,
  chunkUploadMaxRetries: 3,
  chunkUploadRetryDelayMs: 1000,
} as const;

export const VIDEO_MIME_TYPES = {
  mp4: 'video/mp4',
  gp3: 'video/3gpp',
} as const;

export const AUDIO_MIME_TYPES = {
  mp3: 'audio/mpeg',
  wav: 'audio/wav',
};
